var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-height"},[_c('tasks',{staticClass:"full-height",attrs:{"is-mobile":true,"show-all":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }